import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import { toggleLasso, toggleBlockOnClick } from './state/actions';
import { getLassoSelectionMode } from './state/selectors';

class LassoSelection extends Component {
  static propTypes = {
    selectedRecipesById: PropTypes.object.isRequired,
    selectMenuItems: PropTypes.func.isRequired,
    toggleLasso: PropTypes.func,
  };

  static defaultProps = {
    toggleLasso: () => {},
  };

  state = {
    ticking: false,
  };

  componentDidMount() {
    window.addEventListener('mousedown', this.handleMouseDown, false);
    window.addEventListener('mousemove', this.handleMouseMoveTick, false);
    window.addEventListener('mouseup', this.handleMouseUp, false);

    this.window = window;
    this.body = document.body;

    [this.boundingBox] = document.getElementsByClassName(
      'bounding-box-selection-ghost'
    );
    this.boundingBox.setAttribute(
      'style',
      'position:absolute;z-index:999;border: 1px solid #0033ff; background-color: rgb(160,195,255); opacity: 0.5; pointer-events: none'
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.lassoMode && this.props.lassoMode) {
      this.body.style.cursor = 'crosshair';
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleMouseDown, false);
    window.removeEventListener('mousemove', this.handleMouseMoveTick, false);
    window.removeEventListener('mouseup', this.handleMouseUp, false);
  }

  updateBoundingBox = (event) => {
    this.x2 = event.pageX;
    this.y2 = event.pageY;

    this.selectionTop = this.y1 < this.y2 ? this.y1 : this.y2;
    this.selectionLeft = this.x1 < this.x2 ? this.x1 : this.x2;
    this.selectionWidth =
      this.x1 < this.x2 ? this.x2 - this.x1 : this.x1 - this.x2;
    this.selectionHeight =
      this.y1 < this.y2 ? this.y2 - this.y1 : this.y1 - this.y2;
    this.selectionBottom = this.selectionTop + this.selectionHeight;
    this.selectionRight = this.selectionLeft + this.selectionWidth;
  };

  clearBoundingBox = () => {
    this.isSelecting = false;
    this.body.style.cursor = 'default';
    this.boundingBox.style.display = 'none';
  };

  doObjectsCollide = (item) => {
    const itemRect = item.getBoundingClientRect();
    const itemTop = itemRect.top + this.window.scrollY;
    const itemBottom = itemRect.bottom + this.window.scrollY;
    const itemLeft = itemRect.left + this.window.scrollX;
    const itemRight = itemRect.right + this.window.scrollX;

    return (
      itemBottom >= this.selectionTop &&
      itemTop <= this.selectionBottom &&
      itemRight >= this.selectionLeft &&
      itemLeft <= this.selectionRight
    );
  };

  handleMouseDown = (event) => {
    if (!this.props.lassoMode) {
      return;
    }

    this.isSelecting = true;

    // this prevents autoscrolling
    // event.preventDefault();

    this.x1 = event.pageX;
    this.y1 = event.pageY;

    this.boundingBox.style.left = '0px';
    this.boundingBox.style.top = '0px';
    this.boundingBox.style.width = '0px';
    this.boundingBox.style.height = '0px';
    this.boundingBox.style.display = 'block';
    this.updateBoundingBox(event);

    this.draggableItems = Array.from(
      document.querySelectorAll('[data-draggable-id]')
    );
  };

  handleMouseMoveTick = (event) => {
    if (!this.state.ticking) {
      window.requestAnimationFrame(() => {
        this.handleMouseMove(event);
        this.setState({ ticking: false });
      });
      this.setState({ ticking: true });
    }
  };

  handleMouseMove = (event) => {
    if (!this.isSelecting) return;

    this.updateBoundingBox(event);

    // new selection
    this.boundingBox.style.left = `${this.selectionLeft}px`;
    this.boundingBox.style.top = `${this.selectionTop}px`;
    this.boundingBox.style.width = `${this.selectionWidth}px`;
    this.boundingBox.style.height = `${this.selectionHeight}px`;

    // find all draggable items within the boundingBox
    const itemIds = {};
    this.draggableItems.forEach((item) => {
      if (this.doObjectsCollide(item)) {
        itemIds[item.dataset.draggableId] = true;
      }
    });

    if (!isEqual(this.props.selectedRecipesById, itemIds)) {
      this.props.selectMenuItems(Object.keys(itemIds));
    }
  };

  handleMouseUp = (event) => {
    this.clearBoundingBox();
    if (this.props.lassoMode) {
      this.props.toggleLasso();

      //Adds small time buffer so the mouse up event doesn't trigger the onClick event for the day in Month View
      //when releasing the lasso select
      setTimeout(this.props.toggleBlockOnClick, 100);
    }
  };

  render() {
    return <div className="bounding-box-selection-ghost" />;
  }
}

const mapStateToProps = (state) => ({
  lassoMode: getLassoSelectionMode(state),
});

const mapDispatchToProps = {
  toggleLasso,
  toggleBlockOnClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(LassoSelection);



// WEBPACK FOOTER //
// ./src/common/Components/LassoSelection/LassoSelection.js